import { Component, Injectable, OnInit, ViewEncapsulation } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { b2cPolicies, loginRequest } from './_authorization/auth.config';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { Router, RouterModule } from "@angular/router";

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterModule]
})
export class AppComponent implements OnInit {

  title = 'alta-gestao';
  private destroy$ = new Subject<void>();

  constructor(
    private msalBroadcastService: MsalBroadcastService,
    private msalService: MsalService,
    private router: Router
  ) {
    router.events.subscribe(e => console.log(e));
  }

  ngOnInit(): void {
    this.initializeMsalEvents();
  }

  initializeMsalEvents(): void {
    this.msalBroadcastService.msalSubject$
      .pipe(takeUntil(this.destroy$))
      .subscribe((msg: EventMessage) => {

      // LOGIN SUCCESS
      this.loginSucess(msg);

      // LOGIN FAILURE (reset password)
      this.loginFailure(msg);
    });

    this.inProgress();
  }

  loginSucess(msg: EventMessage): void {
    if (msg.eventType === EventType.LOGIN_SUCCESS && msg.payload) {
      const payload = msg.payload as AuthenticationResult;
      const claims = payload.idTokenClaims as Record<string, any> | undefined;
      const policy = claims?.['tfp'] || claims?.['acr'];
      const activeAccount = this.msalService.instance.getActiveAccount();

      if (!activeAccount) {
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.msalService.instance.setActiveAccount(accounts[0]);
        }
      }

      if (policy && policy !== b2cPolicies.names.signUpSignIn) {
        console.warn('Password reset detectado. Forçando novo login.');
        this.msalService.logoutRedirect({
          postLogoutRedirectUri: window.location.origin
        });
      }
    }
  }

  loginFailure(msg: EventMessage): void {
    if (msg.error) {
      const error = msg.error as { errorMessage?: string };
      if (error?.errorMessage?.includes('AADB2C90118')) {
        this.msalService.loginRedirect({
          authority: b2cPolicies.authorities.resetPassword.authority,
          scopes: loginRequest.scopes
        });
      }
    }
  }

  inProgress(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
      });
  }

  checkAndSetActiveAccount(): void {
    let activeAccount = this.msalService.instance.getActiveAccount();
    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      const accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
      activeAccount = accounts[0];
    }

    console.log('Active Account:', activeAccount);

    if (!activeAccount) {
      this.msalService.loginRedirect();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

@Injectable()
export class UploadInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('removeUrl')) {
      return of(new HttpResponse({ status: 200 }));
    }
    return next.handle(req);
  }
}
